import { ModalsModule } from '@modals/modals.module';
import { DirectivesModule } from '@directives/directives.module';
import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ComponentsModule } from '@components/components.module';

import { registerLocaleData } from '@angular/common';
import localePT from '@angular/common/locales/pt-PT';
// import { ServiceWorkerModule } from '@angular/service-worker';

registerLocaleData(localePT);

@NgModule(
    { declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot({
            hardwareBackButton: false,
            backButtonIcon: 'chevron-back-outline',
            mode: 'md'
        }),
        AppRoutingModule,
        ComponentsModule,
        ModalsModule,
        DirectivesModule,
        IonicStorageModule.forRoot({
            name: "smartcard_citizen_bo",
            storeName: "smartcard_citizen_bo_db",
            // driverOrder: ['indexeddb', 'websql', 'sqlite']
        })], providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: LOCALE_ID, useValue: 'pt-PT' },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
